import { Component, OnInit } from '@angular/core';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';
import { investmentDurationOptions2 } from '@app/forms/subscription/services/ref';
import { delay } from 'rxjs';
import { ValidationErrors } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'private-equity-project-duration',
    templateUrl: './private-equity-project-duration.component.html',
    styleUrls: ['./private-equity-project-duration.component.scss'],
    standalone: false
})
export class PrivateEquityProjectDurationComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  projectDurationOptions = investmentDurationOptions2;
  error: ValidationErrors = null;
  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor);
  }
  ngOnInit() {
    const productName =
      this.subscriptionFacade?.getPledge()?.products?.[0]?.productName;
    if (productName?.includes('OCP Business center')) {
      this.projectDurationOptions = [...investmentDurationOptions2.slice(0, 3)];
    }
    this.subscriptionFacade.initForm(this);
    this.formValueChanges();
  }
  formValueChanges() {
    this.form
      .get('investmentDuration')
      .valueChanges.pipe(delay(0), untilDestroyed(this))
      .subscribe(data => {
        if (data == 'MINUS_FIVE') {
          this.form.get('investmentDuration').setErrors({
            incorrect: true,
            message:
              "Vous ne pouvez pas sélectionner cette option. La durée d'investissement est trop courte.",
          });
        } else {
          this.form.get('investmentDuration').setErrors(null);
        }
        this.error = this.form.get('investmentDuration').errors;
      });
  }

  onSubmit() {
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
